
import NavBar from './components/NavBar';
import { Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Footer from './components/Footer';
import LeadershipMessage from './components/LeadershipMessage';
import dirImage from './assets/director.jpeg';
import prinImage from './assets/principal.jpeg';
import viceImage from './assets/vice-principal.jpeg';
import ExcursionGallery from './components/ExcursionGallery';
import StudentCorner from './components/StudentCorner';
import ContactPage from './components/ContactPage';
import SportsActivity from './components/SportsActivity';
import SchoolCalendar from './components/SchoolCalendar';
import SchoolFeeStructure from './components/SchoolFeeStructure';
import DressRulesComponent from './components/DressRulesComponent';
import WelfareSociety from './components/WelfareSociety';
import OurFounder from './components/OurFounder';
import OurHistory from './components/OurHistory';
import AimsObjectives from './components/AimsObjectives';
import SchoolCurriculum from './components/SchoolCurriculum';
import SchoolFacilities from './components/SchoolFacilities';
import SchoolDisclosure from './components/SchoolDisclosure';
export default function App() {
  interface MessageSection {
    title: string;
    content: string;
    icon?: number;
  }

  interface LeadershipMessageProps {
    messageType: 'Director' | 'Principal' | 'Vice Principal';
    name: string;
    title: string;
    quote?: string;
    image?: string;
    sections: MessageSection[];
    closingMessage?: string;
    gradientColors?: {
      from: string;
      to: string;
    };
  }


  // Director's Message Data
  const directorData: LeadershipMessageProps = {
    messageType: 'Director',
    name: 'Mr. Saurabh Pathak',
    title: 'Director / Admin',
    quote: 'Teaching Children to count is fine, but teaching them what counts is best.',
    image: dirImage,
    sections: [
      {
        title: 'Welcome to Excellence',
        content: 'Respected parents and my dear Students, here you are entering into the next phase of schooling where you will definitely see the changes.'
      },
      {
        title: 'Our Vision & Heritage',
        content: 'We at all our venture, are having team of educationists with modern concept of Indian values, who understands the task of this centre of excellence for studies, sports & success.\n\nWe are having a history of more than 30 great years and having successful alumni in different fields of service.'
      },
      {
        title: 'Our Mission',
        content: 'We are in a mission to make sure that every student of the school receives the best education, which starts with access to high quality learning opportunities and continues with a great school, a school ready for upcoming challenges.'
      }
    ],
    closingMessage: 'We have been providing a congenial, competitive, encouraging and compatible atmosphere. Motivation, value based attitudinal change, patience and modesty are the arms and ammunitions to be used to defend materialism, violence dishonesty, corruption and idleness. Along with my Administrative team, Teaching and Non-teaching staff, I thank all who have entrusted us with the great job of Citizen Building of tomorrow.',
    gradientColors: { from: 'blue-600', to: 'purple-700' }
  };

  // Principal's Message Data
  const principalData: LeadershipMessageProps = {
    messageType: 'Principal',
    name: 'Mr. M. S. Parwal',
    title: 'Principal',
    image: prinImage,
    sections: [
      {
        title: 'Our School Motto',
        content: 'Our School Motto "विशेष कलाम" sums up the ethos and commitment of all staff to nurture the potential of every child, developing personal excellence in a caring environment.'
      },
      {
        title: 'Success for All',
        content: 'Success for all students is ensured by the delivery of an enriching and structured curriculum and a whole school focus on student welfare that focuses on the positive recognition of students achievements.'
      },
      {
        title: 'Student Development',
        content: 'All students are taught the skills and values necessary for success in education, life and work. They leave Ever Green Senior Sec. School as literate, numerate, well educated & who have the capability, confidence and independence to make a positive contribution to our society.'
      },
      {
        title: 'Community Partnership',
        content: 'Our School is strengthened by a very supportive parents and wider community and we encourage you to become actively involved in all aspects of your child\'s education. Get to know the staff, especially your child\'s teachers and assist wherever you can, so that we can work together in the interests of everyone.'
      }
    ],
    closingMessage: 'We are continually very proud of our history, our values, and the high standards achieved by our students.\n\nIf any time you would like to speak to me please contact me to make an appointment.',
    gradientColors: { from: 'green-600', to: 'emerald-700' }
  };

  // Vice Principal's Message Data
  const vicePrincipalData: LeadershipMessageProps = {
    messageType: 'Vice Principal',
    name: 'Mr. Rajendra Kumar Pathak',
    title: 'Vice Principal',
    image: viceImage,
    sections: [
      {
        title: 'Quality Education Mission',
        content: 'Ever Green Sr. Sec. School provides quality education for all in a secure and caring environment. Our objective is to inculcate high value and morals in students. We are working hard every year to maintain the pace of student growth which ultimately leads to the growth of the institution. We are thankful to the kind support and guidance given to us from the guardians of our school students and we hope the same support from them in the coming years.'
      }
    ],
    gradientColors: { from: 'purple-600', to: 'violet-700' }
  };

  return (
    <>
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Home />} />
        <Route path="/messages/director" element={<LeadershipMessage {...directorData} />} />
        <Route path="/messages/principal" element={<LeadershipMessage {...principalData} />} />
        <Route path="/messages/vice-principal" element={<LeadershipMessage {...vicePrincipalData} />} />
        <Route path='/excursion' element={<ExcursionGallery />} />
        <Route path='/kids-corner' element={<StudentCorner />} />
        <Route path='/sports-activities' element={<SportsActivity />} />
        <Route path='/school-calendar' element={<SchoolCalendar />} />
        <Route path='/school-fee-structure' element={<SchoolFeeStructure />} />
        <Route path='/dress-rules' element={<DressRulesComponent />} />
        <Route path='/welfare-society' element={<WelfareSociety />} />
        <Route path='/our-founder' element={<OurFounder />} />
        <Route path='/our-history' element={<OurHistory />} />
        <Route path='/aims-objectives' element={<AimsObjectives />} />
        <Route path='/school-curriculum' element={<SchoolCurriculum />} />
        <Route path='/school-facilities' element={<SchoolFacilities />} />
        <Route path='/school-disclosure' element={<SchoolDisclosure />} />
        <Route path='/contact-us' element={<ContactPage />} />
      </Routes>
      <Footer />
    </>
  );
}
